import React, { memo } from 'react'

import { useFormattedTourV2VariationDetailsCount } from 'hooks/TourV2/useTourV2VariationDetails'
import Modal from 'components/Luxkit/Modal/Modal'
import { ImageParams } from 'components/Common/ResponsiveImage'

interface Props {
  variation: App.Tours.TourV2OfferVariation;
}

const IMAGE_PARAMS: ImageParams = { quality: 'good' }

function TourV2RouteMapModal(props: Props) {
  const { variation } = props

  const { variationDetailsCountText } = useFormattedTourV2VariationDetailsCount(variation)

  return <Modal
    image={variation.routeMapImage}
    imageParams={IMAGE_PARAMS}
    size="L"
    subtitle={variationDetailsCountText}
    title={variation.name}
  />
}

export default memo(TourV2RouteMapModal)
